import React from "react";

const DropArrowIcon = ({ dropArrowClasses }) => {
  return (
    <svg
      className={dropArrowClasses}
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.17745 2.48454L4.18328 5.49038C4.6359 5.94299 5.36705 5.94299 5.81966 5.49038L8.82549 2.48454C9.55664 1.7534 9.03439 0.5 8.0015 0.5H1.98984C0.956946 0.5 0.446303 1.7534 1.17745 2.48454Z"
        fill="#94A3B8"
      />
    </svg>
  );
};

export default DropArrowIcon;
